<template>
  <div class="wrap-item">
    <div style="margin-bottom: 12px;">
      <p class="card-title">Tác vụ</p>
      <p class="card-subtitle">Lưu điểm danh, thiết lập và xuất file excel</p>
    </div>

    <div class="sk-dialog__footer flex justify-end items-center">
      <el-button
          type="primary"
          :loading="isSaving"
          :disabled="dirtyCount === 0 || isSaving"
          @click="onSave"
          style="min-width: 110px;"
      >
        Lưu điểm danh
      </el-button>

      <el-dropdown trigger="click" @command="handleExportCommand" class="ml-2">
        <el-button type="success" style="min-width: 110px;">
          Tác vụ <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="constitutive">
            <i class="el-icon-setting"></i> Thiết lập điểm danh
          </el-dropdown-item>
          <el-dropdown-item command="by-date">
            <i class="el-icon-download"></i> Xuất file điểm danh ngày
          </el-dropdown-item>
          <el-dropdown-item command="by-month">
            <i class="el-icon-download"></i> Xuất file điểm danh tháng
          </el-dropdown-item>
          <el-dropdown-item command="general">
            <i class="el-icon-download"></i> Xuất file tổng hợp
          </el-dropdown-item>
          <el-dropdown-item command="general-date">
            <i class="el-icon-download"></i> Xuất file chi tiết tháng
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttendanceFooterAction',
  props: {
    dirtyCount: {type: Number, default: 0},
    isSaving: {type: Boolean, default: false}
  },
  methods: {
    onSave() {
      this.$emit('save');
    },

    /**
     * Hàm bắt sự kiện click vào từng dòng trong menu select dropdown
     * @param {string} command - Tên lệnh tương ứng với từng item
     */
    handleExportCommand(command) {
      switch (command) {
        case 'by-date':
          this.$emit('export-excel-by-date');
          break;
        case "constitutive":
          this.$emit(command);
          break;
        default:
          this.$emit('export-excel', command);
      }
    }
  }
}
</script>

<style scoped>
.sk-dialog__footer {

}

.wrap-item {
  align-items: center;
  background: #ffffff;
  border-radius: 14px;
}

.card-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.card-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.ml-2 {
  margin-left: 0.5rem
}

/* Khoảng cách giữa nút Lưu và nút Menu */
.flex {
  display: flex
}

.justify-end {

}

.items-center {
  align-items: center
}
</style>